export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9210.f2887aaf.jpg";